<template>
    <div>
        <SfModal v-e2e="'login-modal'" :visible="isLoginModalOpen" class="LazyLoginModal" @close="closeModal">
          <template #close>
            <div>
              <SfIcon icon="cross" color="#000"/>
            </div>
          </template>
          <div style="min-height:400px;width:700px;display:flex;">
            <div style="flex:1;text-align: center;padding-top:2rem;">
              <div class="leftContext">
                <h4>你的自定义标题</h4>
                <div style="margin:2rem 0;flex:1;">你的自定义内容</div>
                <div style="padding:0 1rem;">
                  <SfInput v-model="form.username" />
                  <SfButton type="button" style="width:100%">登录</SfButton>
                </div>
              </div>
            </div>
            <div style="flex:1;">
              <div style="background:blue;height:100%;width:100%;"></div>
            </div>
          </div>
        </SfModal>
    </div>
</template>
<script>
import { SfModal, SfInput, SfButton, SfIcon } from '@storefront-ui/vue';
import { useUiState } from '~/composables';
import { ref, watch } from '@nuxtjs/composition-api';
export default {
  name: 'LazyLogin',
  setup() {
    const form = ref({
      username: ''
    });
    const { isLoginModalOpen, toggleLoginModal, isMobile } = useUiState();
    // watch(isLoginModalOpen, () => {
    //   if (isLoginModalOpen.value) {
    //     console.log('fffffff');
    //   }
    // });
    const closeModal = () => {
      toggleLoginModal();
    };
    return {
      isLoginModalOpen,
      toggleLoginModal,
      isMobile,
      form,
      closeModal
    };
  },
  components: {
    SfModal,
    SfInput,
    SfButton,
    SfIcon
  }
};
</script>
<style lang="scss" >
 .LazyLoginModal{
  --modal-width: 700px;
  --modal-content-padding: 0;
  .sf-input{
    input{
      border: 1px solid var(--c-link) !important;
      text-align: left;
      padding:10px 20px;
    }
  }
  .leftContext{
    display:flex;flex-direction: column;
    --leftContextLogin: calc(400px - 6rem);
    height: var(--leftContextLogin);
    max-height: var(--leftContextLogin)
  }
 }
</style>
